import { makeActionCreator } from '../../../utilities'
import { LocationSearchConstants } from './locationSearch.constants'

export const setEnableLocationSearch = makeActionCreator(
  LocationSearchConstants.SET_ENABLE_LOCATION_SEARCH,
  'enableLocationSearch'
)
export const setErrorInfo = makeActionCreator(LocationSearchConstants.SET_ERROR_MSGS_MAP, 'errorMsgsMap')
export const getPatientCityNemsisCode = makeActionCreator(LocationSearchConstants.GET_PATIENT_CITY_NEMSIS_CODE)
export const getPatienteEmployerCityNemsisCode = makeActionCreator(
  LocationSearchConstants.GET_PATIENT_EMPLOYER_CITY_NEMSIS_CODE
)
export const getRefCityNemsisCode = makeActionCreator(LocationSearchConstants.GET_REF_CITY_NEMSIS_CODE)
export const getRecCityNemsisCode = makeActionCreator(LocationSearchConstants.GET_REC_CITY_NEMSIS_CODE)
export const resetLocationSearchState = makeActionCreator(LocationSearchConstants.RESET_LOCATION_SEARCH_STATE)
